import { connect } from 'react-redux';
import { formatPercentage } from '~/utils/Intl';

import Calculation from './Calculation';

const mapStateToProps = () => {
	return {
		formatPercentage,
	};
};

export default connect(mapStateToProps)(Calculation);
